(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["regional-sites"] && !Shopify.designMode) return;
  try {
    let detectedCountryName = '';

  const applyDetectedCountry = (name) => {
    if (!name) return;
    detectedCountryName = name;
    document.querySelectorAll('[data-regional-sites]').forEach((details) => {
      const label = details.querySelector('.regional-sites__label');
      const trigger = details.querySelector('.regional-sites__trigger');
      if (label && label.textContent !== name) label.textContent = name;
      if (trigger) trigger.setAttribute('aria-label', `Regional sites: ${name}`);
    });
  };

  fetch('/browsing_context_suggestions.json')
    .then((response) => response.json())
    .then((data) => {
      const country = data && data.detected_values && data.detected_values.country;
      applyDetectedCountry(country && country.name);
    })
    .catch(() => {});

  new MutationObserver(() => {
    if (detectedCountryName) applyDetectedCountry(detectedCountryName);
  }).observe(document.documentElement, { childList: true, subtree: true });

  document.addEventListener('click', (event) => {
    document.querySelectorAll('[data-regional-sites][open]').forEach((details) => {
      if (!details.contains(event.target)) details.open = false;
    });
  });
  } catch(e) { console.error(e); }
})();

})();
